import { Route, Router, Switch, useLocation } from "react-router-dom";
import "./App.css";
import "../node_modules/rsuite/lib/styles/index.less";
import "./less/base.less";
import _ from "lodash";
import PropTypes from "prop-types";
import React, { Fragment, Suspense, useEffect, useState } from "react";
import ReactPixel from "react-facebook-pixel";
import { useTranslation } from "react-i18next";
import { createUseStyles } from "react-jss";
import { ToastContainer } from "react-toastify";
import tinycolor from "tinycolor2";
import ScrollToTop from "./components/common/ScrollToTop";
import Footer from "./components/Footer/index";
import { brand, GlobalModalsContext, source_entity, withAuth } from "./context";
import { AuthProviderHoc, cStyler, initFacebookPixel } from "./helpers";
import history from "./history";
import { useMetaStuff } from "./hooks";
import { MetaFetcherHoc, ProfileHoc } from "./umbilical_hocs";
import {
  AuthTokenContext,
  CurrencyContext,
  getCurrencyFromStorage,
  StyleTypeContext,
  setCurrencyToStorage,
  setExchangeRatesToStorage,
  TranslationContext,
} from "./umbilical_tools";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { getExchangeRate } from "./api/financial";
import DeepActivitySearchForm from "./components/activities/DeepActivitySearchForm";
import FailedBooking from "./components/common/FailedBooking";
import DeepFerrySearchForm from "./components/ferries/DeepFerrySearchForm";
import DeepFlightSearchForm from "./components/flights/DeepFlightSearchForm";
import DeepHotelSearchForm from "./components/hotels/DeepHotelSearchForm";
import {
  CarRentalContactModal,
  CruiseContactModal,
  FlightContactModal,
} from "./components/MainSearchForm/modals";
import Security from "./components/Security";
import DeepTransferSearchForm from "./components/transfers/DeepTransferSearchForm";
import FullScreenLoader from "./components/widgets/FullScreenLoader";
import { NoScrollContext } from "./context";
import jssVariables from "./jss_setup";
import { SessionLessSuccessfulBooking } from "./pages/addon/AddonSuccesfulBooking";
import { ExtTokenAuth } from "./pages/auth";
import FourOFour from "./pages/fourofour";
import SearchFeedback from "./pages/SearchFeedback";

const LandingPage = React.lazy(() => import("./pages/LandingPage"));
const HotelDetails = React.lazy(() => import("./pages/hotels/HotelDetails"));

import DeepHotel from "./pages/DeepHotel";
import DeepHotelSearch from "./pages/DeepHotel/DeepHotelSearch";

const HotelBookingProcess = React.lazy(() => import("./components/hotels/HotelBookingProcess"));
const FlightBookingProcess = React.lazy(() => import("./components/flights/FlightBookingProcess"));

const Ferries = React.lazy(() => import("./pages/Ferries"));
const FerryDetails = React.lazy(() => import("./pages/Ferries/FerryDetails"));

import ActivityBookingProcess from "./components/activities/ActivityBookingProcess";
import FerriesBookingProcess from "./components/ferries/FerriesBookingProcess";
import ActivityDetails from "./pages/ActivityDetails";
import DeepActivitySearch from "./pages/DeepActivity/DeepActivitySearch";
import DeepFerrySearch from "./pages/DeepFerry/DeepFerrySearch";
import DeepFlightSearch from "./pages/DeepFlight/DeepFlightSearch";

const Transfers = React.lazy(() => import("./pages/Transfers"));

import TransferBookingProcess from "./components/transfers/TransferBookingProcess";
import DeepTransferSearch from "./pages/DeepTransfer/DeepTransferSearch";

const CarRentals = React.lazy(() => import("./pages/CarRentals"));

import CarRentalBookingProcess from "./components/carRentals/CarRentalBookingProcess";

const Trains = React.lazy(() => import("./pages/Trains"));

import DeepTrainSearchForm from "./components/trains/DeepTrainSearchForm";
import DeepTrainSearch from "./pages/DeepTrain/DeepTrainSearch";

const AddonsList = React.lazy(() => import("./pages/addon/list"));
const AddonDetails = React.lazy(() => import("./pages/addon/details"));
const AddonBookingProcess = React.lazy(() => import("./pages/addon/AddonBookingProcess"));

const RestaurantsList = React.lazy(() => import("./pages/restaurant/list"));
const Tours = React.lazy(() => import("./pages/Tours"));

import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import TrainsBookingProcess from "./components/trains/TrainsBookingProcess";
import MyProfile from "./pages/MyProfile";
import PackageDetails from "./pages/package/details";
import { QuotationRequestChat } from "./pages/QuotationRequestChat";

const DynamicPackage = React.lazy(() => import("./pages/DynamicPackages"));
const DynamicPackageDetails = React.lazy(
  () => import("./pages/DynamicPackages/DynamicPackageDetails"),
);

import { NavBar } from "./components/common/NavBar";
import SuccessfulBooking from "./components/common/succesful_booking/index.jsx";
import FAQ from "./components/FAQ";
import { ContactUsModal } from "./components/modals/contactus/index.jsx";
import PointsTopUpModal from "./components/modals/pointspopup";
import { useAuthentication } from "./hooks/authentication";
import { useLoginRecord } from "./hooks/authentication/useLoginRecord";
import { AuthNavigator } from "./pages/AuthNavigator/index.jsx";
import Deposit from "./pages/paymentDeposit";
import Registration from "./pages/Registration";
import SearchForm from "./pages/SearchForm";
import HotelsRedirector from "./pages/wordpressRedirector/HotelsRedirector";

const Flights = React.lazy(() => import("./pages/Flights"));
const Activities = React.lazy(() => import("./pages/Activities"));
const Hotels = React.lazy(() => import("./pages/Hotels"));

import TawkMessengerReact from "@tawk.to/tawk-messenger-react";

const type = import.meta.env.VITE_APP_LAYOUT_TYPE || "type1";

const group = import.meta.env.VITE_APP_GROUP_NAME || "";
const meta_api_key = import.meta.env.VITE_APP_META_API_KEY;

function getTawkSetup(langCode: string) {
  if (!["mytravellifestyle"].includes(brand)) return null;

  switch (langCode) {
    case "en-US":
      return {
        propertyId: "655d870591e5c13bb5b28544",
        widgetId: "1hfqlerjg",
      };
    case "JA": {
      return {
        propertyId: "655d870591e5c13bb5b28544",
        widgetId: "1hobjd4ue",
      };
    }
    case "ZH": {
      return {
        propertyId: "655d870591e5c13bb5b28544",
        widgetId: "1hobih5r1",
      };
    }
    case "TH": {
      return {
        propertyId: "655d870591e5c13bb5b28544",
        widgetId: "1hobi2imt",
      };
    }
    default:
      return {
        propertyId: "655d870591e5c13bb5b28544",
        widgetId: "1hfqlerjg",
      };
  }
}

const styles = createUseStyles({
  App: {
    display: "grid",
    fontFamily: jssVariables.fontFamily,
    overflowX: "hidden!important",
  },
  pages: {
    position: "absolute",
    width: "100%",
    overflowX: "clip",
    height: "100%",
    display: (props) => (props.displayApp ? "grid" : "none"),
  },
  [`@media ${jssVariables.media.smallscreen}`]: { pages: { height: "100%" } },
});
// Component to conditionally render Footer based on route
function ConditionalFooter({ type, baseColor, background, textColor }) {
  const location = useLocation();
  const isChatRoute = location.pathname === "/quotation-request-chat";

  if (isChatRoute) {
    return null;
  }

  return <Footer type={type} baseColor={baseColor} background={background} textColor={textColor} />;
}

let App = ({
  token = "",
  guestProfileLoading = true,
  loading = true,
  currency: defaultCurrency = "EUR",
  userIsElligibleToAccess = true,
}) => {
  const [showHtlFormModal, setShowHtlFormModal] = useState(false);
  const [showFlFormModal, setShowFlFormModal] = useState(false);
  const [showTrfFormModal, setShowTrfFormModal] = useState(false);
  const [showActFormModal, setShowActFormModal] = useState(false);
  const [showFerFormModal, setShowFerFormModal] = useState(false);
  const [showTraFormModal, setShowTraFormModal] = useState(false);
  const [showFlightContactModal, setShowFlightContactModal] = useState(false);
  const [showCruiseContactModal, setShowCruiseContactModal] = useState(false);
  const [showCarRentalContactModal, setShowCarRentalContactModal] = useState(false);
  const [showTopUpPointsModal, setShowTopUpPointsModal] = useState(false);
  const [showContactUsModal, setShowContactUsModal] = useState(false);

  const [noScroll, setNoScroll] = useState<boolean>(false);
  const [displayApp, setDisplayApp] = useState(true);
  const classes = styles({ displayApp });
  const { t, i18n } = useTranslation();
  const [currency, setCurrency] = useState(getCurrencyFromStorage() || "EUR");

  useAuthentication({
    guestProfileLoading,
    userIsElligibleToAccess,
  });

  // Track login record on page load
  useLoginRecord();

  function changeCurrency(input) {
    setCurrency(input);
    setCurrencyToStorage(input);
  }

  useMetaStuff();

  const supported_pages = useSelector(
    (state) => state.WebsiteMetadata?.metadata?.supported_pages ?? [],
  );

  const ordered_sections = useSelector((state) =>
    _.orderBy(state.WebsiteMetadata?.metadata?.landing_page?.descriptive_sections ?? [], "order"),
  );
  const currencies = useSelector((state) => state.WebsiteMetadata?.metadata?.currencies ?? []);
  const multi_currency = currencies.length > 1;

  // Get curencies
  useEffect(() => {
    if (!defaultCurrency) return;

    const promises = [];
    const availableCurrencies = [
      "USD",
      "GBP",
      "AUD",
      "CAD",
      "CNY",
      "HKD",
      "ZAR",
      "KRW",
      "MXN",
      "BRL",
      "TRV",
    ];
    for (let key in availableCurrencies) {
      promises.push(
        getExchangeRate({
          base_currency: "EUR",
          target_currency: availableCurrencies[key],
          source_entity,
        }),
      );
    }

    Promise.all(promises)
      .then((values) => {
        const payload = { base_currency: "EUR", rates: {} };
        values.forEach((val) => {
          payload.rates = { ...payload.rates, ...val.rates };
        });
        setExchangeRatesToStorage(payload);
      })
      .catch(() => {
        return;
      });

    const storageCurrency = getCurrencyFromStorage();

    if (!storageCurrency || (!multi_currency && storageCurrency !== defaultCurrency)) {
      changeCurrency(defaultCurrency);
    }
  }, [defaultCurrency]);

  // Facebook Messenger stuff
  useEffect(() => {
    if (!meta_api_key) {
      return;
    }

    var chatbox = document.getElementById("fb-customer-chat");
    chatbox.setAttribute("page_id", meta_api_key);
    chatbox.setAttribute("attribution", "biz_inbox");

    window.fbAsyncInit = function () {
      window.FB.init({ xfbml: true, version: "v15.0" });
    };

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];

      if (d.getElementById(id)) return;

      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_GB/sdk/xfbml.customerchat.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  // Facebook Pixel Stuff
  useEffect(() => {
    initFacebookPixel();
    ReactPixel.pageView();
  }, []);

  const tawkSetup = getTawkSetup(i18n.language);

  return (
    <AuthTokenContext.Provider value={{ token }}>
      <StyleTypeContext.Provider value={{ type, brand, group, cStyler }}>
        <NoScrollContext.Provider
          value={{ noScroll, toggleNoScroll: (value: boolean) => setNoScroll(value) }}
        >
          <CurrencyContext.Provider value={{ currency, defaultCurrency, changeCurrency }}>
            <TranslationContext.Provider value={{ t, i18n }}>
              <GlobalModalsContext.Provider
                value={{
                  setShowHtlFormModal,
                  setShowFlFormModal,
                  setShowTrfFormModal,
                  setShowActFormModal,
                  setShowFerFormModal,
                  setShowTraFormModal,
                  setShowFlightContactModal,
                  setShowCruiseContactModal,
                  setShowCarRentalContactModal,
                  setShowTopUpPointsModal,
                  setShowContactUsModal,
                }}
              >
                <Router history={history}>
                  <Suspense fallback={<div>Loading...</div>}>
                    <ScrollToTop />
                    <div
                      className={`${classes.App} App`}
                      data-noscroll={noScroll ? "true" : "false"}
                    >
                      {loading || !(supported_pages || []).length ? (
                        <FullScreenLoader />
                      ) : (
                        <Fragment>
                          <NavBar setDisplayApp={setDisplayApp} />{" "}
                          <div
                            id="pages"
                            className={`${classes.pages} pages`}
                            data-noscroll={noScroll ? "true" : "false"}
                          >
                            <Switch>
                              <Route exact path="/authnavigator" render={() => <AuthNavigator />} />
                              {supported_pages.includes("landing") && (
                                <Route exact path="/" render={() => <LandingPage type={type} />} />
                              )}
                              {/* // ============ PAYMENT DEPOSIT =========== */}
                              <Route path="/paymentDeposit/" exact>
                                <Deposit />
                              </Route>
                              {/* // ============ START HOTEL ROUTES =========== */}
                              <Route
                                path="/hotels/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return (
                                    <Hotels min_rating={0} page_session_id={page_session_id} />
                                  );
                                }}
                              />
                              <Route
                                path="/hotel_details/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return <HotelDetails page_session_id={page_session_id} />;
                                }}
                              />
                              <Route
                                path="/deep-hotel/:hotelReference"
                                render={({ match }) => {
                                  const hotelReference = match?.params?.hotelReference ?? "";
                                  return (
                                    <DeepHotel hotelReference={hotelReference} history={history} />
                                  );
                                }}
                              />
                              <Route
                                path="/deep-hotel-search/:encoded_data"
                                render={({ match }) => {
                                  const encoded_data = match?.params?.encoded_data ?? "";
                                  return <DeepHotelSearch encoded_data={encoded_data} />;
                                }}
                              />
                              <Route
                                path="/hotel_details/booking_process/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return <HotelBookingProcess page_session_id={page_session_id} />;
                                }}
                              />
                              <Route
                                exact
                                path="/hotel/successful-booking/:page_session_id"
                                render={({ match }) => {
                                  const session_id = match?.params?.page_session_id ?? "";
                                  return (
                                    <SuccessfulBooking
                                      page_session_id={session_id}
                                      product_type="accommodation"
                                    />
                                  );
                                }}
                              />
                              {/* // ========= END HOTELS ROUTES ========= */}
                              {/* // ======== START FLIGHTS ROUTES ======= */}
                              <Route path="/flights/" exact>
                                <Flights type={type} />
                              </Route>
                              <Route
                                path="/flights/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return <Flights type={type} page_session_id={page_session_id} />;
                                }}
                              />
                              <Route
                                exact
                                path="/deep-flight-search/:encoded_data"
                                render={({ match }) => {
                                  const encoded_data = match?.params?.encoded_data ?? "";
                                  return <DeepFlightSearch encoded_data={encoded_data} />;
                                }}
                              />
                              <Route
                                path="/flights/booking_process/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return <FlightBookingProcess page_session_id={page_session_id} />;
                                }}
                              />
                              <Route
                                exact
                                path="/flights/successful-booking/:page_session_id"
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return (
                                    <SuccessfulBooking
                                      page_session_id={page_session_id}
                                      product_type="flight"
                                    />
                                  );
                                }}
                              />
                              {/* // ======== END FLIGHTS ROUTES ========= */}
                              {/* // ======= START FERRIES ROUTES ======== */}
                              <Route path="/ferries/" exact>
                                <Ferries type={type} />
                              </Route>
                              <Route
                                path="/ferries/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return <Ferries type={type} page_session_id={page_session_id} />;
                                }}
                              />
                              <Route
                                path="/ferry_details/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return <FerryDetails page_session_id={page_session_id} />;
                                }}
                              />
                              <Route
                                exact
                                path="/deep-ferry-search/:encoded_data"
                                render={({ match }) => {
                                  const encoded_data = match?.params?.encoded_data ?? "";
                                  return <DeepFerrySearch encoded_data={encoded_data} />;
                                }}
                              />
                              <Route
                                path="/ferries/booking_process/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return (
                                    <FerriesBookingProcess page_session_id={page_session_id} />
                                  );
                                }}
                              />
                              <Route
                                exact
                                path="/ferries/successful-booking/:page_session_id"
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return (
                                    <SuccessfulBooking
                                      page_session_id={page_session_id}
                                      product_type="ferry"
                                    />
                                  );
                                }}
                              />
                              {/* // ======== END FERRIES ROUTES ========= */}
                              {/* // ======== START TOURS ROUTES ========= */}
                              <Route
                                exact
                                path="/tour/:tourReference"
                                render={({ match }) => {
                                  const [product_type, product_reference] =
                                    match.params.tourReference.split("_");

                                  return (
                                    <AddonDetails
                                      tourReference={product_reference}
                                      productType={product_type}
                                    />
                                  );
                                }}
                              />
                              <Route
                                exact
                                path="/tour/booking_process/:page_session_id"
                                render={({ match }) => {
                                  const session_id = match?.params?.page_session_id ?? "";
                                  return <AddonBookingProcess page_session_id={session_id} />;
                                }}
                              />
                              <Route
                                exact
                                path="/tour/successful-booking/:page_session_id"
                                render={({ match }) => {
                                  const session_id = match?.params?.page_session_id ?? "";
                                  return (
                                    <SuccessfulBooking
                                      page_session_id={session_id}
                                      product_type="addon"
                                    />
                                  );
                                }}
                              />
                              {/* // ========= END TOURS ROUTES ========== */}
                              {/* // ====== START ACTIVITIES ROUTES ====== */}
                              <Route
                                path="/activities/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return <Activities page_session_id={page_session_id} />;
                                }}
                              />
                              <Route
                                path="/activity_details/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  const activity_uid = match?.params?.activity_uid ?? "";
                                  return (
                                    <ActivityDetails
                                      page_session_id={page_session_id}
                                      activity_uid={activity_uid}
                                    />
                                  );
                                }}
                              />
                              <Route
                                exact
                                path="/deep-activity-search/:encoded_data"
                                render={({ match }) => {
                                  const encoded_data = match?.params?.encoded_data ?? "";
                                  return <DeepActivitySearch encoded_data={encoded_data} />;
                                }}
                              />
                              <Route
                                path="/activity_details/booking_process/:page_session_id/:prebook"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  const prebook = match?.params?.prebook ?? "";
                                  return (
                                    <ActivityBookingProcess
                                      page_session_id={page_session_id}
                                      prebook={prebook}
                                    />
                                  );
                                }}
                              />
                              <Route
                                exact
                                path="/activity/successful-booking/:page_session_id"
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return (
                                    <SuccessfulBooking
                                      page_session_id={page_session_id}
                                      product_type="activity"
                                    />
                                  );
                                }}
                              />
                              {/* // ======== END ACTIVITIES ROUTES ======== */}
                              {/* // ======== START TRANSFERS ROUTES ======= */}
                              <Route path="/transfers/" exact>
                                <Transfers />
                              </Route>
                              <Route
                                path="/transfers/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return <Transfers page_session_id={page_session_id} />;
                                }}
                              />
                              <Route
                                exact
                                path="/deep-transfer-search/:encoded_data"
                                render={({ match }) => {
                                  const encoded_data = match?.params?.encoded_data ?? "";
                                  return <DeepTransferSearch encoded_data={encoded_data} />;
                                }}
                              />
                              <Route
                                path="/transfer/booking_process/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return (
                                    <TransferBookingProcess page_session_id={page_session_id} />
                                  );
                                }}
                              />
                              <Route
                                exact
                                path="/transfer/successful-booking/:page_session_id"
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return (
                                    <SuccessfulBooking
                                      page_session_id={page_session_id}
                                      product_type="transfer"
                                    />
                                  );
                                }}
                              />
                              {/* // ========= END TRANSFERS ROUTES ======== */}
                              {/* // ======== START CAR RENTAL ROUTES ====== */}
                              <Route path="/car-rentals/" exact>
                                <CarRentals />
                              </Route>
                              <Route
                                path="/car-rentals/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return <CarRentals page_session_id={page_session_id} />;
                                }}
                              />
                              <Route
                                path="/car-rentals/booking_process/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return (
                                    <CarRentalBookingProcess page_session_id={page_session_id} />
                                  );
                                }}
                              />
                              <Route
                                exact
                                path="/car-rental/successful-booking/:page_session_id"
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return (
                                    <SuccessfulBooking
                                      page_session_id={page_session_id}
                                      product_type="car_rental"
                                    />
                                  );
                                }}
                              />
                              {/* // ======== END CAR RENTAL ROUTES ====== */}
                              {/* // ========= START TRAINS ROUTES ======= */}
                              <Route path="/trains/" exact>
                                <Trains />
                              </Route>
                              <Route
                                path="/trains/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return <Trains page_session_id={page_session_id} />;
                                }}
                              />
                              <Route
                                path="/trains/booking_process/:page_session_id"
                                exact
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return <TrainsBookingProcess page_session_id={page_session_id} />;
                                }}
                              />{" "}
                              <Route
                                exact
                                path="/train/successful-booking/:page_session_id"
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return (
                                    <SuccessfulBooking
                                      page_session_id={page_session_id}
                                      product_type="train"
                                    />
                                  );
                                }}
                              />
                              <Route
                                exact
                                path="/deep-train-search/:encoded_data"
                                render={({ match }) => {
                                  const encoded_data = match?.params?.encoded_data ?? "";
                                  return <DeepTrainSearch encoded_data={encoded_data} />;
                                }}
                              />
                              {/* // ========== END TRAINS ROUTES ======== */}
                              {/* // ========== START PKG ROUTES ========= */}
                              <Route
                                path="/package/:tourReference"
                                render={({ match }) => {
                                  const product_type = match?.params?.tourReference.split("_")?.[0];
                                  const product_reference =
                                    match.params?.tourReference.split("_")?.[1];

                                  return (
                                    <PackageDetails
                                      tourReference={product_reference}
                                      productType={product_type}
                                    />
                                  );
                                }}
                              />
                              {/* // =========== END PKG ROUTES ========== */}
                              {/* // ========= START DYNAMIC PKG ROUTES ========= */}
                              <Route
                                exact
                                path="/dynpkg/:pkgReference"
                                render={({ match }) => {
                                  const reference = match.params.pkgReference;
                                  return <DynamicPackage reference={reference} />;
                                }}
                              />
                              <Route
                                exact
                                path="/dynpkg_details/:pkgReference"
                                render={({ match }) => {
                                  const reference = match.params.pkgReference;
                                  return <DynamicPackageDetails reference={reference} />;
                                }}
                              ></Route>
                              {/* // ========= END DYNAMIC PKG ROUTES ========= */}
                              {/* // ======== START WORDPRESS REDIRECTOR ROUTES ======= */}
                              <Route
                                exact
                                path="/hotels-redirector/:session_id"
                                render={({ match }) => {
                                  const session_id = match?.params?.session_id ?? "";
                                  return <HotelsRedirector session_id={session_id} />;
                                }}
                              />
                              {/* // ========= END WORDPRESS REDIRECTOR ROUTES ======== */}
                              {/* // ========= START PROMO ROUTES ======== */}
                              {supported_pages.includes("list") && [
                                <Route path="/tours/" exact key="1">
                                  <AddonsList theme="" />
                                </Route>,
                                <Route path="/packages/" exact key="2">
                                  <Tours product_type="PKG" pkg_type="PKG" theme="" />
                                </Route>,
                                <Route path="/hotel_packages/" exact key="3">
                                  <Tours product_type="PKG" pkg_type="ACC" theme="" />
                                </Route>,
                              ]}
                              {supported_pages.includes("list") &&
                                ordered_sections
                                  .filter((section) => section.path)
                                  .filter(
                                    (section) => section.page_type !== "subagent_registration",
                                  )
                                  .map((section, idx) => {
                                    return (
                                      <Route key={idx} path={`/${section.path}`} exact>
                                        {section.path === "faq" ? (
                                          <FAQ />
                                        ) : section.path === "terms-and-conditions" ? (
                                          <TermsAndConditions />
                                        ) : section.product_category === "MI" ? (
                                          <AddonsList theme={section.theme} />
                                        ) : section.product_category === "REST" ? (
                                          <RestaurantsList />
                                        ) : section.product_category === "ACC" ? (
                                          <Tours
                                            product_type="PKG"
                                            pkg_type="ACC"
                                            theme={section.theme}
                                          />
                                        ) : (
                                          <SearchForm
                                            product_type={section.product_category}
                                            theme={section.theme}
                                          />
                                        )}
                                      </Route>
                                    );
                                  })}
                              {/* // ========== END PROMO ROUTES ========= */}
                              {/* // ========== START DINING ROUTES ========= */}
                              <Route path="/dining/" exact>
                                <RestaurantsList theme="restaurants" />
                              </Route>
                              {/* // =========== END DINING ROUTES ========= */}
                              {/* // ========= START AUTH ROUTES ========= */}
                              <Route exact path="/auth/">
                                <ExtTokenAuth
                                  history={history}
                                  guestProfileLoading={guestProfileLoading}
                                />
                              </Route>
                              <Route exact path="/my_profile">
                                <MyProfile />
                              </Route>
                              <Route exact path="/quotation-request-chat">
                                <QuotationRequestChat />
                              </Route>
                              {/* // ========== END AUTH ROUTES ========== */}
                              {/* // ==== START REGISTRATION ROUTES ====== */}
                              {ordered_sections
                                .filter((section) => section.page_type === "subagent_registration")
                                .map((section, idx) => (
                                  <Route
                                    key={idx}
                                    exact
                                    path={`/${section.path}`}
                                    render={() => (
                                      <Registration path={section.path} theme={section.theme} />
                                    )}
                                  />
                                ))}
                              {/* // ===== END REGISTRATION ROUTES ======= */}
                              {/* // ========= START VIVA ROUTES ========= */}
                              <Route
                                exact
                                path="/viva_success"
                                render={() => <SessionLessSuccessfulBooking />}
                              />
                              <Route exact path="/viva_failure" render={() => <FailedBooking />} />
                              {/* // ========== END VIVA ROUTES ========== */}
                              {/* // ========= START MISC ROUTES ========= */}
                              <Route exact path="/failed-booking/">
                                <FailedBooking />
                              </Route>
                              <Route
                                exact
                                path="/failed-booking/:page_session_id"
                                render={({ match }) => {
                                  const page_session_id = match?.params?.page_session_id ?? "";
                                  return <FailedBooking page_session_id={page_session_id} />;
                                }}
                              />
                              <Route path="/terms-and-conditions/" exact>
                                <TermsAndConditions
                                  background={jssVariables.colors.background.light}
                                  baseColor={jssVariables.colors.base_color}
                                  textColor={jssVariables.colors.text.dark}
                                  titleTextColor={jssVariables.colors.base_color}
                                />
                              </Route>
                              <Route path="/faq/" exact>
                                <FAQ
                                  background={jssVariables.colors.background.light}
                                  baseColor={jssVariables.colors.base_color}
                                  textColor={jssVariables.colors.text.dark}
                                  titleTextColor={jssVariables.colors.base_color}
                                />
                              </Route>
                              <Route path="/privacy-policy/" exact>
                                <PrivacyPolicy
                                  background={jssVariables.colors.background.light}
                                  baseColor={jssVariables.colors.base_color}
                                  textColor={jssVariables.colors.text.dark}
                                  titleTextColor={jssVariables.colors.base_color}
                                />
                              </Route>
                              <Route path="/security/" exact>
                                <Security
                                  background={jssVariables.colors.background.light}
                                  baseColor={jssVariables.colors.base_color}
                                  textColor={jssVariables.colors.text.dark}
                                  titleTextColor={jssVariables.colors.base_color}
                                />
                              </Route>
                              {/* // ========== END MISC ROUTES ========= */}
                              <Route
                                exact
                                path="/search_feedback/:product_type"
                                render={({ match }) => {
                                  const product_type = match?.params?.product_type ?? "";
                                  return <SearchFeedback product_type={product_type} />;
                                }}
                              />
                              <Route exact path="/404/">
                                <FourOFour />
                              </Route>
                              <Route path="*">
                                <FourOFour />
                              </Route>
                            </Switch>
                            <ConditionalFooter
                              type={type}
                              baseColor={jssVariables.colors.base_color}
                              background={tinycolor(jssVariables.colors.base_color)
                                .lighten(10)
                                .toHexString()}
                              textColor={jssVariables.colors.text.light}
                            />
                          </div>
                          {showHtlFormModal && <DeepHotelSearchForm />}
                          {showFlFormModal && <DeepFlightSearchForm />}
                          {showTrfFormModal && <DeepTransferSearchForm />}
                          {showActFormModal && <DeepActivitySearchForm />}
                          {showFerFormModal && <DeepFerrySearchForm />}
                          {showTraFormModal && <DeepTrainSearchForm />}
                          {showFlightContactModal && (
                            <FlightContactModal onClose={() => setShowFlightContactModal(false)} />
                          )}
                          {showCruiseContactModal && (
                            <CruiseContactModal onClose={() => setShowCruiseContactModal(false)} />
                          )}
                          {showCarRentalContactModal && (
                            <CarRentalContactModal
                              onClose={() => setShowCarRentalContactModal(false)}
                            />
                          )}
                          {showTopUpPointsModal && (
                            <PointsTopUpModal onClose={() => setShowTopUpPointsModal(false)} />
                          )}
                          {showContactUsModal && (
                            <ContactUsModal onClose={() => setShowContactUsModal(false)} />
                          )}
                          {!!tawkSetup && (
                            <TawkMessengerReact
                              propertyId={tawkSetup.propertyId}
                              widgetId={tawkSetup.widgetId}
                            />
                          )}
                        </Fragment>
                      )}
                    </div>
                  </Suspense>
                </Router>
                <ToastContainer position="top-center" autoClose={5000} />
              </GlobalModalsContext.Provider>
            </TranslationContext.Provider>
          </CurrencyContext.Provider>
        </NoScrollContext.Provider>
      </StyleTypeContext.Provider>
    </AuthTokenContext.Provider>
  );
};
App.defaultProps = { userIsElligibleToAccess: true };
App.propTypes = {
  userIsElligibleToAccess: PropTypes.bool.isRequired,
  token: PropTypes.string,
  guestProfileLoading: PropTypes.bool,
  loading: PropTypes.bool,
  currency: PropTypes.string,
};
App = MetaFetcherHoc(AuthProviderHoc(ProfileHoc(App, withAuth, history)));
export default App;
